var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow_down_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.957 0h20v20h-20z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow_down_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.175 6.913 10 10.729l3.825-3.817L15 8.087l-5 5-5-5z"
  }))));
};
export default SvgArrowDown;